import { useAuth } from "../contexts/AuthContext";
import { useLists } from "./queries/useLists";
import { canMoveOrDelete } from "../lib/listSharing";
import type { Task } from "../types";

/**
 * Whether this person may delete this Task (ADR-0003: its Author always
 * may, otherwise only the List's Owner).
 *
 * A Delete offered to anyone else looks like it works and then undoes
 * itself: the tasks DELETE policy narrows the statement to zero rows and
 * reports no error, so the optimistic removal and its "deleted" toast both
 * go ahead, and the Task reappears on the next refetch. Every screen that
 * offers Delete asks here first, the same check iOS makes before it draws
 * its own swipe action and editor button.
 *
 * With no signed-in viewer there is nobody to answer the question about, so
 * it answers yes and leaves the refusal to the database — matching
 * useSharedListSync, which does the same for the Task dialog. The app never
 * reaches that state (RootLayout shows the landing page instead), but a
 * component test that mounts a card without an auth user does, and a gate
 * that quietly disagreed with the dialog's would be worse than no gate.
 */
export function useCanDeleteTask(
  task: Pick<Task, "user_id" | "list_id">,
): boolean {
  const { user } = useAuth();
  const { data: lists = [] } = useLists();
  return !user || canMoveOrDelete(task, user.id, lists);
}
